import { createOutlineIcon } from "../createIcon";

export const PlusOutlineIcon = createOutlineIcon(
  <>
    <path d="M12 6v12m6-6H6" />
  </>,
  "PlusOutlineIcon"
);
